import { useDispatch, useSelector } from "react-redux"
import { AppDispatch } from "../../../../../../store"
import { Dialog } from "primereact/dialog"
import { InterviewFlow } from "../../../interface"
import { useEffect, useRef, useState } from "react"
import { Field, Form } from "react-final-form"
import { InputText } from "primereact/inputtext"
import { InputTextarea } from "primereact/inputtextarea"
import { InputNumber } from "primereact/inputnumber"
import { Button } from "primereact/button"
import { generateInterviewFlow, generateInterviewFlowByJob } from "../../../InterviewSetup/InterviewFlowAction"
import { Toast } from "primereact/toast"
import { typesOfId } from "../../../InterviewSetup/enums"

interface FlowTemplateDialogProps {
  displayGenerateFlowDialog: boolean
  retrieveInterviewFlow: any
  onHide: any
}

const GenerateFlowDialog = (props: FlowTemplateDialogProps) => {
  const {displayGenerateFlowDialog, onHide, retrieveInterviewFlow} = props

  const toast = useRef<any>();
  const dispatch = useDispatch<AppDispatch>()
  const { loading, interviewFlow } = useSelector((state: any) => state.interviewFlow)

  const [generationType, setGenerationType] = useState<string>('custom')
  const [numberOfQuestion, setNumberOfQuestion] = useState<number>(5)

  // check with generate type based on interviewflow
  useEffect(() => {
    if (interviewFlow.jobId !== null) {
      setGenerationType('job')
    } else {
      setGenerationType('custom')
    }
  }, [interviewFlow])

  const generateFlow = (values: any) => {
    if (interviewFlow.id) {
      const flowData = {
        interviewFlowId: interviewFlow.id,
        numberOfQuestion: numberOfQuestion,
      };

      const successCallback = () => {
        onHide(true); // Close the dialog

        // refresh interview flow
        dispatch(retrieveInterviewFlow
          ({id: Number(interviewFlow.id), typeOfId: typesOfId[typesOfId.Id]}))

        // show message
        toast.current.show({
          severity: 'success',
          summary: 'Interview Flow Generated',
          detail: `Interview Flow has been generated successfully`,
          life: 3000
        })
      };

      if (generationType === 'job') {
        dispatch(generateInterviewFlowByJob(flowData))
          .then(successCallback)
      } else {
        dispatch(generateInterviewFlow({ 
          ...flowData, 
          jobTitle: values.jobTitle, 
          jobDescription: values.setJobDescription
        }))
          .then(successCallback)
      }
    }
  };

  const validate = (values: any) => {
    const errors: any = {};
    if (generationType === 'custom') {
      if (!values.jobTitle) {
        errors.jobTitle = 'Job Title is required';
      }
      if (!values.jobDescription) {
        errors.jobDescription = 'Job Description is required';
      }
    }
    if (!numberOfQuestion) {
      errors.numberOfQuestion = 'Number of Questions is required';
    }
    return errors;
  }

  return (
    <>
      <Toast ref={toast} />
      <Dialog
        className="w-6"
        visible={displayGenerateFlowDialog}
        onHide={onHide}
        header="Generate Interview Flow using AI">
        <div className="card">
          <Form
            onSubmit={generateFlow}
            validate={validate}
            initialValues={{ numberOfQuestion: numberOfQuestion }}
            render={({ handleSubmit, values }) => (
              <form onSubmit={handleSubmit}>
                {generationType === 'custom' ? (
                  <>
                    <div className="field">
                      <label htmlFor="jobTitle" className="font-medium">
                        Job Title
                      </label>
                      <Field name="jobTitle">
                        {({ input, meta }) => (
                          <>
                            <InputText
                              id="jobTitle"
                              className="w-full"
                              {...input}
                            />
                            {meta.error && meta.touched && <small className="p-error">{meta.error}</small>}
                          </>
                        )}
                      </Field>
                    </div>
                    <div className="field">
                      <label htmlFor="jobDescription" className="font-medium">
                        Job Description
                      </label>
                      <Field name="jobDescription">
                        {({ input, meta }) => (
                          <>
                            <InputTextarea
                              id="jobDescription"
                              rows={4}
                              className="w-full"
                              {...input}
                            />
                            {meta.error && meta.touched && <small className="p-error">{meta.error}</small>}
                          </>
                        )}
                      </Field>
                    </div>
                  </>
                ) : null}

                <div className="field">
                  <label htmlFor="numberOfQuestion" className="font-medium">
                    Number of Questions
                  </label>
                  <Field name="numberOfQuestion">
                    {({ input, meta }) => (
                      <>
                        <InputNumber
                          id="numberOfQuestion"
                          className="w-full"
                          value={values.numberOfQuestion}
                          onChange={(e) => setNumberOfQuestion(e.value || 5)}
                          onValueChange={(e) => setNumberOfQuestion(e.value || 5)}
                        />
                        {meta.error && meta.touched && <small className="p-error">{meta.error}</small>}
                      </>
                    )}
                  </Field>
                </div>
                <Button label="Generate" type="submit" disabled={loading} />
              </form>
            )}
          />
        </div>
      </Dialog >
    </>
  )
}

export default GenerateFlowDialog
